import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 請求攔截器
api.interceptors.request.use(
  config => {
    // 自動加入 session id
    const sessionId = localStorage.getItem('cart_session_id');
    if (sessionId) {
      config.headers['x-session-id'] = sessionId;
    }

    // 加入用戶手機號碼（部分前台顯示用；訂單查詢已改用簽章 token，不再信任此明文欄位）
    const userPhone = localStorage.getItem('user_phone');
    if (userPhone) {
      config.headers['x-user-phone'] = userPhone;
    }

    // 加入會員 token（已簽章，供訂單查詢等以身分驗證，取代明文手機號）
    const authToken = localStorage.getItem('authToken');
    if (authToken) {
      config.headers['x-auth-token'] = authToken;
    }

    // 加入管理員 token（後台 API 認證用）
    const adminToken = localStorage.getItem('admin_token');
    if (adminToken) {
      config.headers['Authorization'] = `Bearer ${adminToken}`;
    }

    return config;
  },
  error => Promise.reject(error)
);

// 回應攔截器
api.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default api;
